// firebase/index
export const firebaseConfig = {
  apiKey: "AIzaSyDaje3mbd6dkJmlVb024EdUft06easoeJ4",
  authDomain: "infraymin2021.firebaseapp.com",
  projectId: "infraymin2021",
  storageBucket: "infraymin2021.appspot.com",
  messagingSenderId: "503470861555",
  appId: "1:503470861555:web:7ca9fb2bb4370aae3d1b86",
  measurementId: "G-GHKX79MTWQ"
}

// firebase/storage
export const storageUrl = 'https://firebasestorage.googleapis.com/v0/b/infraymin2021.appspot.com/o/'